<template>
  <v-container
    class="my-12"
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        md="8"
      >
        <v-card>
          <v-card-title
            primary-title
            class="mb-4"
          >
            <v-flex
              xs12
              class="text-center"
            >
              <v-icon
                x-large
                class="blue--text text--darken-2"
              >
                mdi-email
              </v-icon>
              <div
                class="display-1"
              >
                E-Mail-Verification:
              </div>
            </v-flex>
          </v-card-title>

          <v-card-text>
            <p class="text-center body-1 green--text" v-if="success">
              Deine neue E-Mail-Adresse wurde gespeichert. <br>Ab sofort kannst Du dich nur noch mit Deiner neuen E-Mail-Adresse einloggen.
            </p>
            <p v-else class="text-center body-1">
              Deine neue E-Mail-Adresse konnte momentan nicht gespeichert werden<br> oder der Sicherheitscode passt nicht zu Deiner E-Mail-Adresse.<br>Schreibe mir eine E-Mail um das Probem ggf. anders zu lösen.
            </p>

            <my-alert
              v-if="this.$store.state.error || verificationError"
              :error="this.$store.state.error || verificationError"
              :title="this.$store.state.errorTitle || verificationTitle"
              type="error"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ROOT_LOADING } from '../../store/mutation-types'
export default {
  name: 'EMailverification',
  metaInfo: {
    title: 'E-Mail-Verification'
  },
  data () {
    return {
      verificationError: false,
      verificationTitle: 'Fehler',
      success: false
    }
  },
  async created () {
    if (this.$store.state.matchEvaluationInProgress) {
      this.verificationError = 'Die Auswertung läuft gerade. Bitte warte bis die Auswertung abgeschlossen ist und klicke dann erneut auf den Link in der E-Mail'
    } else {
      // sende email und token ans backend
      this.$store.commit(ROOT_LOADING, true)

      const sendEMailVerifyToken = await this.$store.dispatch('loginRegisterStore/sendEmailVerificationToken', {
        token: this.$route.params.code,
        email: this.$route.params.email
      })
      if (sendEMailVerifyToken) {
        this.success = true
        this.verificationError = false
      }
    }
  },
  methods: {

  }
}
</script>
